import { Autocomplete, TextField } from "@mui/material";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import { CountriesList, Employee } from "../types/processTypes";
import { ETHIOPIA_REGIONS } from "./regionAutocompleteUtils";

interface RegionAutocompleteProps {
  formikProps: FormikProps<Employee>;
}

export const RegionAutocomplete = ({ formikProps }: RegionAutocompleteProps) => {
  const { t } = useTranslation();
  const regionValue = formikProps.values.address?.region ?? "";

  // Legacy values not in the canonical list stay visible until re-selected.
  const options =
    regionValue && !ETHIOPIA_REGIONS.includes(regionValue)
      ? [regionValue, ...ETHIOPIA_REGIONS]
      : ETHIOPIA_REGIONS;

  const setRegion = (value: string) => {
    const currentAddress = formikProps.values.address ?? {
      region: "",
      city: "",
      telephone: "",
      country: CountriesList.ethiopia,
    };
    formikProps.setFieldValue("address", {
      ...currentAddress,
      region: value,
    });
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={options}
      autoHighlight
      value={regionValue || null}
      onChange={(_, newValue) => setRegion(newValue ?? "")}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t("region")}
          sx={{ mt: 1 }}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};
